<template>
  <!-- Draws the sound sheets opened with soundSheets.open(kind, sound).
       Every kind but buy takes { show, sound, sounds } and emits
       update:show and done(updatedSounds). Buy keeps PurchaseDialog's own
       API; its `licensed` becomes done([{ ...sound, isOwned: true }]). Each
       done is re-emitted to soundSheets.onChange listeners. -->
  <SoundDetailsSheet
    v-if="kind === 'details'"
    :key="`d${state.seq}`"
    v-model:show="show"
    :sound="state.sound"
    :sounds="state.sounds"
    @done="done"
  />
  <PurchaseDialog
    v-if="kind === 'buy' && buy"
    :key="`b${state.seq}`"
    v-model:show="show"
    :loop-hash="buy.hash"
    :loop-name="buy.title"
    :seller-username="buy.creator"
    :min-price="buy.min"
    :suggested-price="buy.suggested"
    @licensed="onLicensed"
  />
  <SetPriceSheet
    v-if="kind === 'setPrice'"
    :key="`p${state.seq}`"
    v-model:show="show"
    :sound="state.sound"
    :sounds="state.sounds"
    @done="done"
  />
  <EditSoundSheet
    v-if="kind === 'editDetails'"
    :key="`e${state.seq}`"
    v-model:show="show"
    :sound="state.sound"
    :sounds="state.sounds"
    @done="done"
  />
  <RenameSoundDialog
    v-if="kind === 'rename'"
    :key="`r${state.seq}`"
    v-model:show="show"
    :sound="state.sound"
    :sounds="state.sounds"
    @done="done"
  />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { soundSheetState, close, emitChange } from "./soundSheets.js";

export default {
  name: "SoundSheetsHost",
  components: {
    SoundDetailsSheet: defineAsyncComponent(() => import("@/components/sounds/SoundDetailsSheet.vue")),
    PurchaseDialog: defineAsyncComponent(() => import("@/components/PurchaseDialog.vue")),
    SetPriceSheet: defineAsyncComponent(() => import("@/components/library/SetPriceSheet.vue")),
    EditSoundSheet: defineAsyncComponent(() => import("@/components/library/EditSoundSheet.vue")),
    RenameSoundDialog: defineAsyncComponent(() => import("@/components/library/RenameSoundDialog.vue")),
  },
  data: () => ({ state: soundSheetState }),
  computed: {
    kind() {
      return this.state.kind;
    },
    show: {
      get() {
        return !!this.state.kind;
      },
      set(v) {
        if (!v) close();
      },
    },
    // The buy sheet's props from a Sound.
    buy() {
      const s = this.state.sound;
      if (!s) return null;
      return {
        hash: s.hash,
        title: s.title,
        creator: s.creator,
        min: (s.price && s.price.checkoutMinUsd) || 0,
        suggested: s.price && s.price.suggestedUsd != null ? s.price.suggestedUsd : null,
      };
    },
  },
  methods: {
    done(updated) {
      emitChange(updated);
    },
    onLicensed() {
      const s = this.state.sound;
      if (s) emitChange([{ ...s, isOwned: true }]);
    },
  },
};
</script>
